export const routes = {
    DEFAULT: '/accounts',
    PARTNER_INTEGRATIONS: '/partner-integrations',
    CLIENT_METRICS: '/client-metrics',
    INBOUND_CONNECTIONS: '/inbound-connections',
    USER_ADMIN_POC: '/internal/user-admin-poc',
} as const;
